import { Canvas, useFrame } from '@react-three/fiber';
import { Stars } from '@react-three/drei';
import { Suspense } from 'react';
import * as THREE from 'three';
import { Planet } from './Planet';
import { Fire } from './Fire';
import { WatchPlaceholder } from './WatchPlaceholder';

function CameraRig({ progress }: { progress: number }) {
  useFrame(({ camera }) => {
    const descent = THREE.MathUtils.smoothstep(progress, 0.24, 0.46);
    const watch = THREE.MathUtils.smoothstep(progress, 0.58, 0.75);
    camera.position.x = THREE.MathUtils.lerp(0, 1.2, watch);
    camera.position.y = THREE.MathUtils.lerp(0.2, -0.15, descent);
    camera.position.z = THREE.MathUtils.lerp(8.2, 5.3, descent);
    camera.lookAt(0, 0, 0);
  });
  return null;
}

export function Experience({ progress }: { progress: number }) {
  return (
    <Canvas dpr={[1, 1.75]} camera={{ position: [0, 0.2, 8.2], fov: 42 }} gl={{ antialias: true, powerPreference: 'high-performance' }}>
      <color attach="background" args={['#030304']} />
      <fog attach="fog" args={['#030304', 8, 20]} />
      <ambientLight intensity={0.2} />
      <directionalLight position={[5, 3, 5]} intensity={3.5} color="#d8e5ff" />
      <Suspense fallback={null}>
        <Stars radius={90} depth={30} count={1600} factor={2.5} saturation={0} fade speed={0.25} />
        <Planet progress={progress} />
        <Fire progress={progress} />
        <WatchPlaceholder progress={progress} />
        <CameraRig progress={progress} />
      </Suspense>
    </Canvas>
  );
}
